import { useEffect, useState } from "react";

const RightLongArrowIcon = ({ className, fill }) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={fill}
      className={_class}
    >
      <path
        d="M13.5929 4.9143C13.5517 4.87987 13.5188 4.83745 13.4963 4.79017C13.4737 4.7429 13.4621 4.69187 13.4621 4.64033C13.4621 4.5888 13.4737 4.53777 13.4963 4.49049C13.5188 4.44322 13.5517 4.4008 13.5929 4.36637C13.6342 4.33193 13.6825 4.30532 13.7342 4.2885C13.786 4.27168 13.8401 4.26505 13.8942 4.26898C13.9484 4.27291 14.0012 4.28732 14.0493 4.31128C14.0974 4.33525 14.1396 4.36827 14.1732 4.40858L18.1929 8.42833C18.2342 8.46277 18.2671 8.50518 18.2897 8.55245C18.3122 8.59972 18.3238 8.65075 18.3238 8.70229C18.3238 8.75383 18.3122 8.80486 18.2897 8.85213C18.2671 8.8994 18.2342 8.94182 18.1929 8.97626L14.1732 13.006C14.1396 13.0463 14.0974 13.0793 14.0493 13.1033C14.0012 13.1273 13.9484 13.1417 13.8942 13.1456C13.8401 13.1495 13.786 13.1429 13.7342 13.1261C13.6825 13.1093 13.6342 13.0827 13.5929 13.0482C13.5517 13.0138 13.5188 12.9714 13.4963 12.9241C13.4737 12.8768 13.4621 12.8258 13.4621 12.7743C13.4621 12.7227 13.4737 12.6717 13.4963 12.6244C13.5188 12.5771 13.5517 12.5347 13.5929 12.5003L16.8619 9.2033H2.16663C2.05581 9.2033 1.94953 9.15891 1.87139 9.08077C1.79325 9.00263 1.74886 8.89635 1.74886 8.78553C1.74886 8.67471 1.79325 8.56843 1.87139 8.49029C1.94953 8.41215 2.05581 8.36777 2.16663 8.36777H16.8619L13.5929 4.9143Z"
        fill={fill || "#6F6F6F"}
        strokeWidth="1"
      />
    </svg>
  );
};

export default RightLongArrowIcon;
